// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"e_gC","legend":"e_hC","legendContent":"e_iC","contentWrapper":"e_jC","fieldsetContent":"e_kC"};